import { createI18n } from 'vue-i18n';

const messages = {
    en: {
        calendar: {
            week: 'Calendar Week {week}',
            previous_week: 'Previous Week',
            current_week: 'Current Week',
            next_week: 'Next Week',
            edit_event: 'Edit Event',
            new_event: 'New Event',
            jira_id: 'Jira ID',
            jira_id_placeholder: 'e.g. PROJ-123',
            customer: 'Customer',
            select_customer: 'Select a customer',
            project: 'Project',
            select_project: 'Select a project',
            activity: 'Activity',
            select_activity: 'Select an activity',
            description: 'Description',
            cancel: 'Cancel',
            delete: 'Delete',
            save: 'Save'
        }
    },
    de: {
        calendar: {
            week: 'Kalenderwoche {week}',
            previous_week: 'Vorherige Woche',
            current_week: 'Aktuelle Woche',
            next_week: 'Nächste Woche',
            edit_event: 'Ereignis bearbeiten',
            new_event: 'Neues Ereignis',
            jira_id: 'Jira ID',
            jira_id_placeholder: 'z.B. PROJ-123',
            customer: 'Kunde',
            select_customer: 'Kunde auswählen',
            project: 'Projekt',
            select_project: 'Projekt auswählen',
            activity: 'Aktivität',
            select_activity: 'Aktivität auswählen',
            description: 'Beschreibung',
            cancel: 'Abbrechen',
            delete: 'Löschen',
            save: 'Speichern'
        }
    }
};

export const i18n = createI18n({
    locale: document.documentElement.lang || 'de', // get from html lang attribute
    fallbackLocale: 'en',
    messages,
    legacy: false // Set to true if using Vue 2
});